import { Box, Typography } from '@mui/material';

import { FORTA_GRAY4 } from '../../../../../utils/colors';
import {
  RELATIONSHIP_MANAGER_ICON_BOX_SX,
  RELATIONSHIP_MANAGER_LABEL_SX,
  RELATIONSHIP_MANAGER_ROW_SX,
} from '../styles';

import type { RelationshipManagerRowProps } from '../types';

function RelationshipManagerRow({
  icon,
  iconWidth,
  iconHeight,
  label,
}: RelationshipManagerRowProps) {
  return (
    <Box sx={RELATIONSHIP_MANAGER_ROW_SX}>
      <Box sx={RELATIONSHIP_MANAGER_ICON_BOX_SX}>
        <img src={icon} alt="" width={iconWidth} height={iconHeight} />
      </Box>
      <Typography
        fontSize={14}
        lineHeight={1.5}
        color={FORTA_GRAY4}
        sx={RELATIONSHIP_MANAGER_LABEL_SX}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default RelationshipManagerRow;
